import React from "react";
import { Page } from "ui/components";
import PulseLoader from "react-spinners/PulseLoader";

import logo from "../assets/logo-driver.png";

const SplashScreen = ({ style }) => {
  return (
    <Page className="bg-container-image align-items-center">
      <img src={logo} alt="" className="img-fluid" height={30} />
      <div className="mt-3">
        <PulseLoader color="#2f83ba" size={15} />
      </div>
    </Page>
  );
};

export default SplashScreen;
